import Typography from '@mui/material/Typography';
import { Stack } from '@src/common/components/Stack';
import type { HTMLAttributes } from 'react';

export type ClientForSelector = {
  id: string;
  name: string;
  doingBusinessAs?: string;
};

const isClientForSelector = (option: unknown): option is ClientForSelector => {
  return (
    typeof option === 'object' &&
    option !== null &&
    ('name' in option || 'doingBusinessAs' in option)
  );
};

export const getClientSelectOptionLabel = (option: unknown): string => {
  if (typeof option === 'string') return option;
  if (isClientForSelector(option)) {
    return option.doingBusinessAs ?? option.name ?? '';
  }
  console.warn(
    'Invalid option type was provided to getClientSelectOptionLabel',
    option,
  );
  return '';
};

export const filterClientSelectOptions = (
  options: unknown[],
  state: unknown,
): unknown[] => {
  const { inputValue } = state as { inputValue: string };
  const userEntry = inputValue.toLowerCase();
  return options.filter((option) => {
    if (isClientForSelector(option)) {
      const nameMatches = option.name.toLowerCase().includes(userEntry);
      const dbaMatches =
        option.doingBusinessAs?.toLowerCase().includes(userEntry) ?? false;
      return nameMatches || dbaMatches;
    }
    return false;
  });
};

export const renderClientSelectOption = (
  props: HTMLAttributes<HTMLLIElement>,
  option: unknown,
) => {
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { key, ...propsWithoutKey } = props;
  if (!isClientForSelector(option)) {
    console.warn(
      'Invalid option type was provided to getClientSelectOption',
      option,
    );

    return <span key="unknown-element" {...propsWithoutKey} />;
  }
  const client = option;
  return (
    <span key={client.id} {...propsWithoutKey}>
      <Stack>
        {client.doingBusinessAs ? (
          <>
            <Typography variant="body1" sx={{ fontWeight: 500 }}>
              {client.doingBusinessAs}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {client.name}
            </Typography>
          </>
        ) : (
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {client.name}
          </Typography>
        )}
      </Stack>
    </span>
  );
};
